import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ProductionService } from '@app/shared/services/production.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

import * as XLSX from 'xlsx';


@Component({
  selector: 'app-prod-rec',
  templateUrl: './prod-rec.component.html',
  styleUrls: ['./prod-rec.component.css']
})
export class ProdRecComponent implements OnInit {
   productionForm: FormGroup;
    productionId: string;
  
  
  
  
    // Mapping for Material Categories to Specifications
    materialSpecificationsMap = {
      'CLEAR BOPP ': ['CLEAR BOPP [950mm X 18Î¼m]', 'CLEAR BOPP [930mm X 18Î¼m]', 'CLEAR BOPP [720mm X 40Î¼m]'],
      'MET BOPP': ['MET BOPP 40mm * 45mm', 'MET BOPP 70mm * 90mm'],
      'ADDITIVES': ['ADDITIVES'],
      'C BOPP': ['C BOPP'],
      'CLEAR CPP': ['CLEAR CPP 5mm * 4mm', 'CLEAR CPP 7mm * 9mm'],
      'PEARLIZED BOPP': ['PEARLIZED BOPP'],
      'PET': ['PET'],
      'PET G': ['PET G'],
    };
  
    // Specifications based on selected category
    matSpecifications: string[] = [];
    paginatedOrderList: any[] = [];
  
  
  
    //table
    materialMixEntries: any[] = [];
    currentPage: number = 1;
    itemsPerPage: number = 15;
  
  
    //extended table(based on process selection)
     // Define flags for each process type
     isAddProduction: boolean = false;
     isInking: boolean = false;

     productions: any[] = [];

     //grouping
     groupedEntries: any[] = [];

     searchOperator: string = '';
     searchTicketNo: string = '';
     paginatedEntries: any[] = [];
     filteredEntries: any[] = [];
   
     totalPages: number = 1;
    //  by date
    searchDate: string = '';  // For storing selected date
  

  constructor( private productionService: ProductionService, private cdr: ChangeDetectorRef, private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.loadAllProductions();
  }


  // Method to load all productions(without grouping)
  // loadAllProductions(): void {
  //   this.productionService.getAllProduction().subscribe(
  //     (productions) => {
  //       console.log('Loaded productions:', productions); // Check the structure of productions
  //       if (Array.isArray(productions)) {
  //         this.materialMixEntries = productions; // Only assign if it's an array
  //         console.log('Updated materialMixEntries:', this.materialMixEntries); // Log materialMixEntries after update
  //         this.cdr.detectChanges(); // Trigger change detection

  //       } else {
  //         console.error('Expected an array of productions, but got:', productions);
  //         this.materialMixEntries = []; // Set it to an empty array if it's not an array
  //       }
  //     },
  //     (error) => {
  //       console.error('Error loading productions:', error);
  //     }
  //   );
  // }



  //(with pagination and searches)
  loadAllProductions(): void {
    this.productionService.getAllProduction().subscribe(
      (productions) => {
        console.log('Loaded productions:', productions);
        if (Array.isArray(productions)) {
          this.materialMixEntries = productions.reverse();
          this.filteredEntries = this.materialMixEntries;
          this.totalPages = Math.ceil(this.filteredEntries.length / this.itemsPerPage);
          this.updatePaginatedEntries();
          this.cdr.detectChanges();
        } else {
          console.error('Expected an array of productions, but got:', productions);
          this.materialMixEntries = [];
          this.filteredEntries = [];
          this.paginatedEntries = [];
        }
      },
      (error) => {
        console.error('Error loading productions:', error);
      }
    );
  }
//(with grouping)(without pagination and searches)
// loadAllProductions(): void {
//   this.productionService.getAllProduction().subscribe(
//     (productions) => {
//       console.log('Loaded productions:', productions);  // Log raw data
      
//       if (Array.isArray(productions)) {
//         this.materialMixEntries = productions.reverse();; // Set raw data
//         // this.groupEntriesByCommonFields();  // Group entries by common fields
//         this.cdr.detectChanges(); // Trigger change detection
//       } else {
//         console.error('Expected an array of productions, but got:', productions);
//         this.materialMixEntries = [];  // Set it to an empty array if it's not an array
//       }
//     },
//     (error) => {
//       console.error('Error loading productions:', error);
//     }
//   );
// }

 // New method to handle matRollNo logic
 getMatRollNoString(entry: any): string {
  if (entry.addProduction && entry.addProduction.length > 0) {
    return entry.addProduction.map(addProd => addProd.matRollNo || 'N/A').join(', ');
  }
  return 'N/A'; // Default if no matRollNo exists
}

 // Method to handle inkColor
 getInkColorString(entry: any): string {
  if (entry.inking && entry.inking.length > 0) {
    return entry.inking.map(ink => ink.inkColor || 'N/A').join(', ');
  }
  return 'N/A'; 
}

 filterTable(): void {
  this.filteredEntries = this.materialMixEntries.filter((entry) => {
    const operatorMatch = entry.operator
      ?.toLowerCase()
      .includes(this.searchOperator.toLowerCase());
    const ticketNoMatch = entry.refNo
    ?.toLowerCase()
      .includes(this.searchTicketNo.toLowerCase());

const matchDate = this.searchDate ? this.isDateMatch(entry.created, this.searchDate) : true;  // Filter by created date
//     return operatorMatch && ticketNoMatch;
return operatorMatch && ticketNoMatch && matchDate;
  });

  this.totalPages = Math.ceil(this.filteredEntries.length / this.itemsPerPage);
  this.currentPage = 1;
   this.updatePaginatedEntries();
 }

 //with date
// filterTable(): void {
//   this.filteredEntries = this.materialMixEntries.filter(entry => {
//     const matchOperator = this.searchOperator ? entry.operator?.toLowerCase().includes(this.searchOperator.toLowerCase()) : true;
//     const matchTicketNo = this.searchTicketNo ? entry.refNo?.toLowerCase().includes(this.searchTicketNo.toLowerCase()) : true;
//     const matchDate = this.searchDate ? this.isDateMatch(entry.created, this.searchDate) : true;  // Filter by created date

//     return matchOperator && matchTicketNo && matchDate;
//   });

//   this.totalPages = Math.ceil(this.filteredEntries.length / this.itemsPerPage);
//   this.goToPage(1); // Reset to page 1 after filtering
// }

// Helper function to check if the entry's created date matches the selected search date
isDateMatch(entryDate: string, searchDate: string): boolean {
  const entryDateObj = new Date(entryDate); // Convert string to date object
  const searchDateObj = new Date(searchDate); // Convert string to date object
  return entryDateObj.toDateString() === searchDateObj.toDateString(); // Compare only the date part
}


updatePaginatedEntries(): void {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  this.paginatedEntries = this.filteredEntries.slice(startIndex, endIndex);
}

goToPage(page: number): void {
  if (page < 1 || page > this.totalPages) return;
  this.currentPage = page;
  this.updatePaginatedEntries();
}

deleteProduction(entryId: string) {
  if (confirm('Are you sure you want to delete this Production order?')) {
    this.productionService.deleteProduction(entryId).subscribe(() => {
      this.filteredEntries = this.filteredEntries.filter(productionorder => productionorder._id !== entryId);
      this.cdr.detectChanges();
    }, error => {
      console.error('Error while deleting this entry:', error);
    });
  }
}





// print(entry: any) {
//   const doc = new jsPDF();
  
//   const pageWidth = doc.internal.pageSize.width;
//   const topMargin = 2;
//   const sideMargin = 10;
//   doc.setFont('helvetica');
//   const adjustedTop = topMargin + 8;
//   const adjustedLeft = sideMargin + 10;
//   doc.setFont('helvetica', 'bold');
  
//   const ticketText = 'LEXIPACK GHANA LIMITED';
//   const companyName = entry.clientName || '';
//   const companyJob = `${entry.jobName || ''} (${entry.jobType || ''})`;
//   const textWidth = doc.getTextWidth(ticketText);
//   const textX = (pageWidth - textWidth) / 2;
//   doc.setFontSize(13);
//   doc.text(ticketText, textX, adjustedTop + 2);
//   doc.text(companyName, adjustedLeft, adjustedTop + 10);
//   doc.text(companyJob, adjustedLeft, adjustedTop + 16);
//   doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
//   doc.setFontSize(11);
//   doc.setFont('helvetica', 'normal');

//   // Add other content from the entry object as needed
//   const PoNo = `Po No: ${entry.poNumber || ''}`;
//   doc.text(PoNo, adjustedLeft - 8, adjustedTop + 23);
  
//   // Other document content...
  
//   // Save the PDF
//   const pdfOutput = doc.output('bloburl');
//   window.open(pdfOutput); // Open the PDF in a new tab for preview
// }






//working perfetc with add production and inking (previous form structure)
// print(entry: any) {
//   const doc = new jsPDF();

//   const pageWidth = doc.internal.pageSize.width;
//   const topMargin = 2;
//   const sideMargin = 10;
//   const adjustedTop = topMargin + 8;
//   const adjustedLeft = sideMargin + 10;

//   doc.setFont('helvetica', 'bold');
//   doc.setFontSize(13);

//   // Header
//   const headerText = 'LEXIPACK GHANA LIMITED';
//   const textWidth = doc.getTextWidth(headerText);
//   const textX = (pageWidth - textWidth) / 2;
//   doc.text(headerText, textX, adjustedTop + 2);
  

//   doc.setFontSize(11);
//   doc.setFont('helvetica', 'normal');

//   // // Basic Info
//   // let currentY = adjustedTop + 10;
//   // doc.text(`Client Name: ${entry.clientName || ''}`, adjustedLeft, currentY);
//   // currentY += 6;
//   // doc.text(`Job Name: ${entry.jobName || ''}`, adjustedLeft, currentY);
//   // currentY += 6;

//   // const infoLines = [
//   //   `PO No: ${entry.poNumber || ''}`,
//   //   `Ref No: ${entry.refNo || ''}`,
//   //   // `Shift: ${entry.shift || ''}`,
//   //   // `Machine: ${entry.machine || ''}`,
//   //   `Operator: ${entry.operator || ''}`,
//   //   // `Operating Time: ${entry.operatingTime || ''}`,
//   //   `Machine Speed: ${entry.mcSpeed || ''}`,
//   //   `Ink GSM: ${entry.inkGsm || ''}`,
//   //   // `Order Quantity: ${entry.orderKgs || ''} kg`,
//   //   // `Time From: ${entry.timeFrom || ''}`,
//   //   // `Time To: ${entry.timeTo || ''}`
//   // ];

//   // infoLines.forEach(line => {
//   //   doc.text(line, adjustedLeft, currentY);
//   //   currentY += 6;
//   // });



//   // Sub Header - Printing Report
//   const subHeaderText = 'PRINTING REPORT';
//   const subTextWidth = doc.getTextWidth(subHeaderText);
//   const subTextX = (pageWidth - subTextWidth) / 2;
//   doc.setFontSize(11);
//   doc.text(subHeaderText, subTextX, adjustedTop + 10);

//   doc.setFont('helvetica', 'normal');
//   doc.setFontSize(10);

//   // Start position after header
//   let currentY = adjustedTop + 18;

//   const colSpacing = 90; // space between left and right columns
//   const col1X = adjustedLeft;
//   const col2X = adjustedLeft + colSpacing;

//   // // Left Column: Basic Client Info
//   // doc.text(`Client Name: ${entry.clientName || ''}`, col1X, currentY);
//   // doc.text(`Ref No: ${entry.refNo || ''}`, col2X, currentY);
//   // currentY += 6;

//   // doc.text(`Job Name: ${entry.jobName || ''}`, col1X, currentY);
//   // // doc.text(`PO No: ${entry.poNumber || ''}`, col2X, currentY);
//   // // PO No + Ticket No in one line
//   // const poText = `PO No: ${entry.poNumber || ''}`;
//   // const ticketText = `Ticket No: ${entry.ticketNo || ''}`;
//   // const poTextWidth = doc.getTextWidth(poText);
//   // doc.text(poText, col2X, currentY);
//   // doc.text(ticketText, col2X + poTextWidth + 15, currentY); // spacing of 10 units after PO No
//   // currentY += 6;
//   // // currentY += 6;

//   // doc.text(`Operator: ${entry.operator || ''}`, col1X, currentY);
//   // doc.text(`Machine Speed: ${entry.mcSpeed || ''}`, col2X, currentY);
//   // currentY += 6;

//   // doc.text(``, col1X, currentY); // leave left empty
//   // doc.text(`Ink GSM: ${entry.inkGsm || ''}`, col2X, currentY);

//   // Left Column: Basic Client Info
// //   doc.text(`Job Name: ${entry.jobName || ''}`, col1X, currentY);
// //   // doc.text(`Ticket No: ${entry.ticketNo || ''}`, col2X, currentY);
// //   currentY += 6;

// //   // doc.text(`Date: ${entry.created || ''}`, col1X, currentY);
// //   // to split the date
// // //   const createdDate = entry.created ? entry.created.split('T')[0] : '';
// // // doc.text(`Date: ${createdDate}`, col1X, currentY);
// // // beside
// // const createdDate = entry.created ? entry.created.split('T')[0] : '';
// // const dateText = `Date: ${createdDate}`;
// // const shiftText = `Shift: ${entry.shift || ''}`;
// // const dateTextWidth = doc.getTextWidth(dateText);

// // doc.text(dateText, col1X, currentY);
// // doc.text(shiftText, col1X + dateTextWidth + 15, currentY); // 15 units spacing after date

// //   // doc.text(`PO No: ${entry.poNumber || ''}`, col2X, currentY);
// //   // PO No + Ticket No in one line
// //   const machineText = `Machine: ${entry.machine || ''}`;
// //   const inkGsmText = `Ink GSM: ${entry.inkGsm || ''}`;
// //   const machineTextWidth = doc.getTextWidth(machineText);
// //   doc.text(machineText, col2X, currentY);
// //   doc.text(inkGsmText, col2X + machineTextWidth + 15, currentY); // spacing of 10 units after PO No
// //   currentY += 6;
// //   // currentY += 6;

// //   doc.text(`Operator: ${entry.operator || ''}`, col1X, currentY);
// //   doc.text(`Machine Speed: ${entry.mcSpeed || ''}`, col2X, currentY);
// //   currentY += 6;

// //   doc.text(``, col1X, currentY); // leave left empty
// //   // doc.text(`Ink GSM: ${entry.inkGsm || ''}`, col2X, currentY);
// //   doc.text(`Order No: ${entry.ticketNo || ''}`, col2X, currentY);


// currentY += 20;
 

//   const formattedDate = new Date(entry.created).toISOString().split('T')[0];
//   autoTable(doc, {
//     startY: 25,
//     body: [
//       // First row: Client Name and Order Number spanning 2 columns each
//       [
//         { content: 'Job Name:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 1 },
//         { content: entry.jobName, colSpan: 3 },
//         { content: 'Order Number:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 2 },
//         { content: entry.ticketNo, colSpan: 2 }
//       ],
  
//       // Second row: Date, Shift, Machine, Ink GSM (each taking 2 columns)
//       [
//         { content: 'Date:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         formattedDate,
//         { content: 'Shift:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         entry.shift,
//         { content: 'Machine:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         entry.machine,
//         { content: 'Ink GSM:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         entry.inkGsm
//       ],
  
//       // Third row: Operator and Machine Speed
//       [
//         { content: 'Operator:', styles: { fontStyle: 'bold', fontSize: 10 } ,colSpan: 2},
//         { content: entry.operator, colSpan: 2 },
//         { content: 'Machine Speed:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 2 },
//         { content: entry.mcSpeed, colSpan: 2 },
       
//       ]
//     ],
//     theme: 'grid',
//     styles: { fontSize: 10 },
//     tableWidth: 180,
//     columnStyles: {
//       0: { cellWidth: 22.5 },
//       1: { cellWidth: 22.5 },
//       2: { cellWidth: 22.5 },
//       3: { cellWidth: 22.5 },
//       4: { cellWidth: 22.5 },
//       5: { cellWidth: 22.5 },
//       6: { cellWidth: 22.5 },
//       7: { cellWidth: 22.5 }
//     }
//   });
  
//   // autoTable(doc, {
//   //   startY: 25,
//   //   body: [
//   //     // ['Client Name:', order.clientName, 'Order Status:', order.status],
//   //     [{ content: 'Client Name:', styles: { fontStyle: 'bold',fontSize: 10, }  }, entry.clientName, { content: 'Order Number:',styles: { fontStyle: 'bold',fontSize: 10, } }, entry.ticketNo,
//   //     ],


//   //     [{ content: 'Date', styles: { fontStyle: 'bold', fontSize: 10 } }, entry.created, 
//   //       { content: 'Shift:', styles: { fontStyle: 'bold', fontSize: 10 } },entry.shift,
//   //       { content: 'Machine:', styles: { fontStyle: 'bold', fontSize: 10 } }, entry.machine, 
//   //       { content: 'Ink GSM:', styles: { fontStyle: 'bold', fontSize: 10 } },entry.inkGsm,
//   //     ],
//   //     // [ { content: 'Ref No:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content:entry.refNo|| 'N/A', colSpan: 4 }],
//   //     // [ { content: 'PO No:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content:entry.poNo|| 'N/A', colSpan: 4 }],
      

//   //     // keeping one whole complete row
//   //     // [ { content: 'Operator:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content: entry.operator || 'N/A', colSpan: 4 }],
//   //     // [ { content: 'Machine Speed:', styles: { fontStyle: 'bold', fontSize: 10 } },{ content: entry.mcSpeed|| 'N/A', colSpan: 4 }]
//   //     [{ content: 'Operator:', styles: { fontStyle: 'bold',fontSize: 10, }  }, entry.operator, { content: 'Machine Speed:',styles: { fontStyle: 'bold',fontSize: 10, } }, entry.mcSpeed,
//   //     ],
//   //   ],
//   //   theme: 'grid',
//   //   styles: { fontSize: 10 },
//   //   tableWidth: 180,

//   //   // columnStyles: {
//   //   //   // 0: { cellWidth: 40 },
//   //   //   // 1: { cellWidth: 50 },
//   //   //   // 2: { cellWidth: 40 },
//   //   //   // 3: { cellWidth: 50 }
//   //   //   0: { cellWidth: 40 },
//   //   //   1: { cellWidth: 40 },  // Adjust cell width as needed
//   //   //   2: { cellWidth: 40 },
//   //   //   3: { cellWidth: 40 },
//   //   //   4: { cellWidth: 40 },  // New column for Machine
//   //   //   5: { cellWidth: 40 }   // Adjust for the extra column
//   //   // }
//   //   columnStyles: {
//   //     0: { cellWidth: 20 },
//   //     1: { cellWidth: 20 },
//   //     2: { cellWidth: 20 },
//   //     3: { cellWidth: 20 },
//   //     4: { cellWidth: 20 },
//   //     5: { cellWidth: 20 },
//   //     6: { cellWidth: 20 },
//   //     7: { cellWidth: 20 }
//   //   }
//   // });


//   // Space before tables
//   currentY += 12;

//   // Production Table
//   // if (entry.addProduction?.length) {
//   //   autoTable(doc, {
//   //     startY: currentY,
//   //     head: [['Mat Specification', 'Mat Roll No', 'Prod Weight (kg)', 'Prod Return (kg)']],
//   //     body: entry.addProduction.map((item: any) => [
//   //       item.matSpecifications || 'N/A',
//   //       item.matRollNo || 'N/A',
//   //       item.prodWeight || 'N/A',
//   //       item.prodReturn || 'N/A',
//   //     ]),
//   //     styles: { fontSize: 10 },
//   //     headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//   //   });

//   //   currentY = (doc as any).lastAutoTable.finalY + 10;
//   // }

// // Roll Information Title
// doc.setFont('helvetica', 'bold');
// doc.setFontSize(11);
// doc.text('Roll Information', adjustedLeft, currentY);
// currentY += 2;

// if (entry.addProduction?.length) {
//   autoTable(doc, {
//     startY: currentY,
//     head: [
//       [
//         { content: 'Input', colSpan: 4, styles: { halign: 'center',  fillColor: [220, 220, 220],  textColor: [0, 0, 0], lineWidth: 0.3,} },
//         { content: 'Output', colSpan: 4, styles: { halign: 'center', fillColor: [220, 220, 220],  textColor: [0, 0, 0], lineWidth: 0.3,} }
//       ],
//       [
//         'Material',
//         'Input Roll No',
//         ' Weight (kg)',
//         ' Return (kg)',
      
       
//         ' Output Roll No',
//         ' Output (kg)',
//         ' Flag',
//         ' Wastage'
//       ]
//     ],
//   // Production Table
// // if (entry.addProduction?.length) {
// //   autoTable(doc, {
// //     startY: currentY,
// //     head: [
// //       [
// //         'Mat Specification',
// //         'Mat Roll No',
// //         'Prod Weight (kg)',
// //         'Prod Return (kg)',
// //         'Prod Flag',
// //         'Prod Output (kg)',
// //         'Prod Output Roll No',
// //         'Prod Waste'
// //       ]
// //     ],
//     body: entry.addProduction.map((item: any) => [
//       item.matSpecifications || 'N/A',
//       item.matRollNo || 'N/A',
//       item.prodWeight || 'N/A',
//       item.prodReturn || 'N/A',
      
     
//       item.prodOutputRollNo || 'N/A',
//       item.prodOutputKg || 'N/A',
//       item.prodFlag || 'N/A',
//       item.prodWaste || 'N/A',
//     ]),
//     styles: { fontSize: 10 },
//     headStyles: { fillColor: [41, 128, 185], textColor: 255 ,
//       // lineWidth: 0.5,            // Thicker borders for header
//       // lineColor: [200, 200, 200],
//     },
//   });

//   currentY = (doc as any).lastAutoTable.finalY + 10;
// }


// // Inking Title
// doc.setFont('helvetica', 'bold');
// doc.setFontSize(11);
// doc.text('Ink', adjustedLeft, currentY);
// currentY += 2;
//   // Inking Table
//   if (entry.inking?.length) {
//     autoTable(doc, {
//       startY: currentY,
//       head: [['Ink Name', 'Color', 'Type', 'Issue', 'Return']],
//       body: entry.inking.map((ink: any) => [
//         ink.inkName || 'N/A',
//         ink.inkColor || 'N/A',
//         ink.inkType || 'N/A',
//         ink.issue || 'N/A',
//         ink.inkReturn || 'N/A',
//       ]),
//       styles: { fontSize: 10 },
//       headStyles: { fillColor: [39, 174, 96], textColor: 255 },
//     });
//   }

//   // Breakdown Title
// // currentY = (doc as any).lastAutoTable?.finalY + 10 || currentY + 10;
// // doc.setFont('helvetica', 'bold');
// // doc.setFontSize(11);
// // doc.text('Breakdown', adjustedLeft, currentY);
// // currentY += 2;

// // if (entry.breakdown?.length) {
// //   autoTable(doc, {
// //     startY: currentY,
// //     head: [['DownTime Type', 'Time (Minutes)', 'Remarks']],
// //     body: entry.breakdown.map((item: any) => [
// //       item.downTime || 'N/A',
// //       item.downTimeTime || 'N/A',
// //       item.downTimeRemarks || 'N/A'
// //     ]),
// //     styles: { fontSize: 10 },
// //     headStyles: { fillColor: [231, 76, 60], textColor: 255 },
// //   });
// // }

// // Move to next Y after ink table
// currentY = (doc as any).lastAutoTable?.finalY + 10 || currentY + 10;

// // Section Titles
// doc.setFont('helvetica', 'bold');
// doc.setFontSize(11);
// doc.text('Breakdown', adjustedLeft, currentY - 2);
// doc.text('Solvent ', adjustedLeft + 95, currentY - 2);

// // Tables side by side
// const downtimeTable = {
//   head: [['DownTime Type', 'Time (Min)', 'Remarks']],
//   body: entry.breakdown?.map((item: any) => [
//     item.downTime || 'N/A',
//     item.downTimeTime || 'N/A',
//     item.downTimeRemarks || 'N/A'
//   ]) || [],
// };

// const solventTable = {
//   head: [['Solvent ', 'Type', 'Consumption']],
//   body: entry.solvent?.map((item: any) => [
//     item.mat || 'N/A',
//     item.type || 'N/A',
//     item.consumption || 'N/A'
//   ]) || [],
// };

// // Downtime (left)
// autoTable(doc, {
//   startY: currentY,
//   // margin: { left: adjustedLeft }, // ✅ horizontal position
//   head: downtimeTable.head,
//   body: downtimeTable.body,
//   styles: { fontSize: 10 },
//   headStyles: { fillColor: [231, 76, 60], textColor: 255 },//text color black textColor: 0
//   tableWidth: 90,
//   theme: 'grid'
// });

// // Solvent (right)
// autoTable(doc, {
//   startY: currentY,
//   margin: { left: adjustedLeft + 90 }, // ✅ position beside the downtime table
//   head: solventTable.head,
//   body: solventTable.body,
//   // styles: { fontSize: 10 },
//   // headStyles: { fillColor: [52, 152, 219], textColor: 0 },//text color white textColor: 255
//   styles: { 
//     fontSize: 10, 
//     cellPadding: 2,  // Adds padding inside the cells
//     lineWidth: 0.1,  // Border thickness
//     // lineColor: [0, 0, 0], // Border color (black)
//     lineColor: [169, 169, 169],
//   },
//   headStyles: { 
//     textColor: 30, // White text color
//     fillColor: undefined, // Remove background color
//     lineWidth: 0.1,  // Border thickness for header cells
//     // lineColor: [0, 0, 0], // Border color for header cells
//     lineColor: [169, 169, 169],
//   },
//   tableWidth: 90,
//   theme: 'grid'
// });


//   // Open PDF
//   const pdfOutput = doc.output('bloburl');
//   window.open(pdfOutput);
// }


// 
// print(entry: any) {
//   const doc = new jsPDF();

//   const pageWidth = doc.internal.pageSize.width;
//   const topMargin = 2;
//   const sideMargin = 10;
//   const adjustedTop = topMargin + 8;
//   const adjustedLeft = sideMargin + 10;

//   // Header
//   doc.setFont('helvetica', 'bold');
//   doc.setFontSize(13);
//   const headerText = 'LEXIPACK GHANA LIMITED';
//   const textWidth = doc.getTextWidth(headerText);
//   const textX = (pageWidth - textWidth) / 2;
//   doc.text(headerText, textX, adjustedTop + 2);

//   // Sub Header
//   doc.setFontSize(11);
//   const subHeaderText = 'PRINTING REPORT';
//   const subTextWidth = doc.getTextWidth(subHeaderText);
//   const subTextX = (pageWidth - subTextWidth) / 2;
//   doc.text(subHeaderText, subTextX, adjustedTop + 10);

//   let currentY = adjustedTop + 20;
//   const formattedDate = new Date(entry.created).toISOString().split('T')[0];

//   // Job Info Table
//   autoTable(doc, {
//     startY: currentY,
//     body: [
//       [
//         { content: 'Job Name:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 1 },
//         { content: entry.jobName || 'N/A', colSpan: 3 },
//         { content: 'Order Number:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 2 },
//         { content: entry.ticketNo || 'N/A', colSpan: 2 }
//       ],
//       [
//         { content: 'Date:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         formattedDate,
//         { content: 'Shift:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         entry.shift || '',
//         { content: 'Machine:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         entry.machine || '',
//         { content: 'Ink GSM:', styles: { fontStyle: 'bold', fontSize: 10 } },
//         entry.inkGsm || ''
//       ],
//       [
//         { content: 'Operator:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 2 },
//         { content: entry.operator || '', colSpan: 2 },
//         { content: 'Machine Speed:', styles: { fontStyle: 'bold', fontSize: 10 }, colSpan: 2 },
//         { content: entry.mcSpeed || '', colSpan: 2 }
//       ]
//     ],
//     theme: 'grid',
//     styles: { fontSize: 10 },
//     tableWidth: 180,
//     columnStyles: {
//       0: { cellWidth: 22.5 }, 1: { cellWidth: 22.5 },
//       2: { cellWidth: 22.5 }, 3: { cellWidth: 22.5 },
//       4: { cellWidth: 22.5 }, 5: { cellWidth: 22.5 },
//       6: { cellWidth: 22.5 }, 7: { cellWidth: 22.5 }
//     }
//   });

//   currentY = (doc as any).lastAutoTable.finalY + 10;

//   // === Material Details + Batches ===
//   doc.setFont('helvetica', 'bold');
//   doc.setFontSize(11);
//   doc.text('Material Details + Batches', adjustedLeft, currentY);
//   currentY += 2;

//   const mainHead = [
//     'Serial No', 'Input Roll No', 'Joint', 'Kgs', 'Return', 'Wastage',
//     'Output Roll', 'Kgs', 'Meters', 'Flags', 'Wastage'
//   ];

//   const mainBody: any[][] = [];

//   (entry.materialDetails || []).forEach((row: any, i: number) => {
//     mainBody.push([
//       i + 1,
//       row.woNo || '',
//       row.itemWidth || '',
//       row.itemGross || '',
//       row.itemThickness || '',
//       row.itemWastage || '',
//       row.batchNo || '',
//       row.itemInk || '',
//       row.itemScrap || '',
//       row.itemUsed || '',
//       row.itemBalanced || ''
//     ]);

//     if (Array.isArray(row.batches) && row.batches.length > 0) {
//       row.batches.forEach((batch: any) => {
//         mainBody.push([
//           '', '', '', '', '', '',  // empty for indentation
//           batch.batchNo || '',
//           batch.dialogColor || '',
//           batch.dialogMeter || '',
//           batch.dialogText || '',
//           batch.remark || ''
//         ]);
//       });
//     }

//     mainBody.push([]); // spacer
//   });

//   autoTable(doc, {
//     startY: currentY,
//     head: [mainHead],
//     body: mainBody,
//     styles: { fontSize: 9 },
//     headStyles: { fillColor: [60, 130, 200], textColor: 255 },
//     columnStyles: {
//       0: { cellWidth: 15 },
//       1: { cellWidth: 25 },
//       2: { cellWidth: 20 },
//       3: { cellWidth: 20 },
//       4: { cellWidth: 20 },
//       5: { cellWidth: 20 },
//       6: { cellWidth: 25 },
//       7: { cellWidth: 20 },
//       8: { cellWidth: 20 },
//       9: { cellWidth: 20 },
//       10: { cellWidth: 20 }
//     },
//     theme: 'grid'
//   });

//   currentY = (doc as any).lastAutoTable.finalY + 10;

//   // === Breakdown & Solvent Tables ===
//   doc.setFont('helvetica', 'bold');
//   doc.setFontSize(11);
//   doc.text('Breakdown', adjustedLeft, currentY - 2);
//   doc.text('Solvent', adjustedLeft + 95, currentY - 2);

//   const downtimeTable = {
//     head: [['DownTime Type', 'Time (Min)', 'Remarks']],
//     body: entry.breakdown?.map((item: any) => [
//       item.downTime || 'N/A',
//       item.downTimeTime || 'N/A',
//       item.downTimeRemarks || 'N/A'
//     ]) || [],
//   };

//   const solventTable = {
//     head: [['Solvent', 'Type', 'Consumption']],
//     body: entry.solvent?.map((item: any) => [
//       item.mat || 'N/A',
//       item.type || 'N/A',
//       item.consumption || 'N/A'
//     ]) || [],
//   };

//   autoTable(doc, {
//     startY: currentY,
//     head: downtimeTable.head,
//     body: downtimeTable.body,
//     styles: { fontSize: 10 },
//     headStyles: { fillColor: [231, 76, 60], textColor: 255 },
//     tableWidth: 90,
//     theme: 'grid'
//   });

//   autoTable(doc, {
//     startY: currentY,
//     margin: { left: adjustedLeft + 90 },
//     head: solventTable.head,
//     body: solventTable.body,
//     styles: {
//       fontSize: 10,
//       cellPadding: 2,
//       lineWidth: 0.1,
//       lineColor: [169, 169, 169]
//     },
//     headStyles: {
//       textColor: 30,
//       fillColor: undefined,
//       lineWidth: 0.1,
//       lineColor: [169, 169, 169]
//     },
//     tableWidth: 90,
//     theme: 'grid'
//   });

//   // Open PDF in new tab
//   const pdfOutput = doc.output('bloburl');
//   window.open(pdfOutput);
// }

print(entry: any) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const topMargin = 2;
  const sideMargin = 10;
  const adjustedTop = topMargin + 8;
  const adjustedLeft = sideMargin + 10;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);

  // Header
  const headerText = 'LEXIPACK GHANA LIMITED';
  const textWidth = doc.getTextWidth(headerText);
  doc.text(headerText, (pageWidth - textWidth) / 2, adjustedTop + 2);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);

  // Sub Header
  const subHeaderText = 'PRINTING REPORT';
  const subTextWidth = doc.getTextWidth(subHeaderText);
  doc.text(subHeaderText, (pageWidth - subTextWidth) / 2, adjustedTop + 10);

  let currentY = adjustedTop + 18;
  const formattedDate = new Date(entry.created).toISOString().split('T')[0];

  // Job Info Table
  autoTable(doc, {
    startY: currentY,
    body: [
      [
        { content: 'Job Name:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.jobName || '',
        { content: 'Order Number:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.ticketNo || '',
        { content: 'Ref No:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.refNo || '',
      ],
      [
        { content: 'Date:', styles: { fontStyle: 'bold', fontSize: 10 } },
        formattedDate,
        { content: 'Shift:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.shift || '',
        { content: 'Machine:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.machine || ''
      ],
      [
        { content: 'Operator:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.operator || '',
        { content: 'Machine Speed:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.mcSpeed || '',
        { content: 'Ink GSM:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.inkGsm || ''
      ]
    ],
    theme: 'grid',
    styles: { fontSize: 10 },
    tableWidth: 'auto',

    margin: {
      left: sideMargin - 0  // 👈 shift it left by 5 units
    },
    
    columnStyles: {
      0: { cellWidth: 25 },
      1: { cellWidth: 55 },
      2: { cellWidth: 20 },
      3: { cellWidth: 42 },
      4: { cellWidth: 22 },
      5: { cellWidth: 20 },
    }
  });

  currentY = (doc as any).lastAutoTable.finalY + 8;

  // Material + Batch Table Title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  // doc.text('Input + Output', adjustedLeft, currentY);
  doc.text('Input + Output', sideMargin, currentY);
  currentY += 4;

  // Table headers
  const unifiedHead = [[
    'S/N', 'Input Roll', 'Joint', 'Kgs', 'Return', 'Wastage',
    'Output Roll', 'Kgs', 'Meters', 'Flags', 'Wastage'
  ]];

  // Build table body
  const unifiedBody: any[][] = [];
  // (entry.materialDetails || []).forEach((row: any, i: number) => {
  //   const batches = Array.isArray(row.batches) ? row.batches : [];

  //   if (batches.length > 0) {
  //     batches.forEach((batch: any, idx: number) => {
  //       if (idx === 0) {
  //         unifiedBody.push([
  //           i + 1,
  //           row.woNo || '',
  //           row.itemWidth || '',
  //           row.itemGross || '',
  //           row.itemThickness || '',
  //           row.itemWastage || '',
  //           batch.batchNo || '',
  //           batch.dialogColor || '',  //for kgs (batch dialog)
  //           batch.dialogMeter || '',  //for metrs
  //           batch.dialogText || '',  //for flag
  //           batch.remark || ''       //for wastage
  //         ]);
  //       } else {
  //         unifiedBody.push([
  //           '', '', '', '', '', '',
  //           batch.batchNo || '',
  //           batch.dialogColor || '',
  //           batch.dialogMeter || '',
  //           batch.dialogText || '',
  //           batch.remark || ''
  //         ]);
  //       }
  //     });
  //   } else {
  //     unifiedBody.push([
  //       i + 1,
  //       row.woNo || '',
  //       row.itemWidth || '',
  //       row.itemGross || '',
  //       row.itemThickness || '',
  //       row.itemWastage || '',
  //       '', '', '', '', ''
  //     ]);
  //   }
  // });

  // after rowspan for materialDetails
  (entry.materialDetails || []).forEach((row: any, i: number) => {
    const batches = Array.isArray(row.batches) ? row.batches : [];
  
    if (batches.length > 0) {
      batches.forEach((batch: any, idx: number) => {
        if (idx === 0) {
          // First batch: show everything
          unifiedBody.push([
            i + 1,
            row.woNo || '',
            row.itemWidth || '',
            row.itemGross || '',
            row.itemThickness || '',
            row.itemWastage || '',
            batch.batchNo || '',
            batch.dialogColor || '',
            batch.dialogMeter || '',
            batch.dialogText || '',
            batch.remark || ''
          ]);
        } else {
          // Additional batches: input columns hidden (spanned visually)
          unifiedBody.push([
            { content: '', colSpan: 6, styles: { cellPadding: 0 } }, // input section hidden
            batch.batchNo || '',
            batch.dialogColor || '',
            batch.dialogMeter || '',
            batch.dialogText || '',
            batch.remark || ''
          ]);
        }
      });
    } else {
      // No batches: just input
      unifiedBody.push([
        i + 1,
        row.woNo || '',
        row.itemWidth || '',
        row.itemGross || '',
        row.itemThickness || '',
        row.itemWastage || '',
        '', '', '', '', ''
      ]);
    }
  });

  
  

  // Table footer for totals
  const unifiedFoot = [
    [
      '', '', entry.totalJoint || '0', entry.totalKgs || '0',
      entry.totalReturn || '0', entry.totalWastage || '0',
      '', entry.totalOutputKgs || '0', entry.totalOutputMeters || '0',
      entry.totalOutputFlags || '0', entry.totalOutputWastage || '0'
    ],

    [
      '', '', 
      { content: 'Return :', styles: { fontStyle: 'bold' } }, 
      entry.totalReturn || '0.00',
      '', '', 
      { content: 'Wastage :', styles: { fontStyle: 'bold' } }, 
      entry.totalOutputWastage || '0.00',
      '', '', ''
    ],
    
    [
      '',   { content: 'Net Consumption :', colSpan: 2,  styles: { fontStyle: 'bold',  fillColor: [180, 180, 180], } },
      { content: entry.netConsumption || '0', styles: { fontStyle: 'bold',  fillColor: [180, 180, 180], } },

      // '', '',  { content: 'Net Total :', styles: { fontStyle: 'bold' } },
      // entry.netTotalConsumption || '0'
        '', '',  { content: 'Net Total :', styles: { fontStyle: 'bold',fillColor: [180, 180, 180], } },
        { content: entry.netTotalConsumption || '0', styles: { fontStyle: 'bold',   fillColor: [180, 180, 180], }},
    ] //green fillColor: [0, 197, 105],  textColor: 255
  ];

  // Margins for table
  const leftMargin = sideMargin;
  const rightMargin = sideMargin;
  const tableWidth = pageWidth - leftMargin - rightMargin;

  autoTable(doc, {
    startY: currentY,
    head: unifiedHead,
    body: unifiedBody,
    foot: unifiedFoot,
    theme: 'grid',
    styles: {
      fontSize: 9,
      cellPadding: 1.5,
    },
    headStyles: {
      fillColor: [60, 130, 200],
      textColor: 255,
      cellPadding: { top: 3, bottom: 3, left:2 } // ⬅ Increase header height here
    },
    footStyles: {
      fillColor: [240, 240, 240],
      fontStyle: 'bold',
      textColor: 20,
    },
    margin: { left: leftMargin, right: rightMargin },
    tableWidth: 'auto',
    columnStyles: {
      0: { cellWidth: 10 },   // S/N
      1: { cellWidth: 18 },   // Input Roll  //now here (use colspan and '', this includes space)
      2: { cellWidth: 18 },   // Joint
      3: { cellWidth: 14 },   // Kgs    //for net consumption also
      4: { cellWidth: 18 },   // Return
      5: { cellWidth: 18 },   // Input Wastage
      6: { cellWidth: 20 },   // Output Roll
      7: { cellWidth: 18 },   // Output Kgs
      8: { cellWidth: 18 },   // Meters
      9: { cellWidth: 17 },   // Flags
      10: { cellWidth: 17 }   // Output Wastage  //total 190  exactly 210mm
    }
  });
  

  // Open PDF in new tab
  // const pdfOutput = doc.output('bloburl');
  // window.open(pdfOutput);



  
  currentY = (doc as any).lastAutoTable.finalY + 10;

// ------- Inking Summary ---------
doc.setFont('helvetica', 'bold');
doc.setFontSize(11);
// doc.text('Inks', adjustedLeft, currentY);
doc.text('Inks', sideMargin, currentY); //for alignment with table
currentY += 4;

autoTable(doc, {
  startY: currentY,
  head: [['Ink Name', 'Ink Color', 'Ink Type', 'Issue (Kgs)', 'Return (Kgs)', 'Liquid Cons', 'Solid %', 'Solid Cons']],
  body: (entry.inking || []).map((ink: any) => [
    ink.inkName,
    ink.inkColor,
    ink.inkType,
    ink.issue,

    // '', // Return can be blank if not stored per ink
    ink.return,

    ink.liquidCons,
    ink.solidPercent,
    ink.solidCons
  ]),
  foot: [[
    'Total', '', '', entry.totalInkIssue || '0',
    entry.totalInkReturn || '0',
    entry.totalInkLiquidCons || '0',
    '', entry.totalInkSolidCons || '0'
  ]],
  theme: 'grid',
  styles: { fontSize: 9 },
  margin: { left: sideMargin, right: sideMargin },
  tableWidth: 'auto',

  footStyles: {
    fillColor: [240, 240, 240],  //gray color
    textColor: 20,
    fontStyle: 'bold'
  },
  headStyles: {
    fillColor: [60, 130, 200],
    textColor: 255
  },
});

currentY = (doc as any).lastAutoTable.finalY + 8;





// ------- Solvent + Breakdown Side-by-Side ---------
// const solventX = adjustedLeft;
const solventX = 10;  //to shift this table a bit left
const breakdownX = pageWidth / 2 + 2;
const sideTableY = currentY;

// Solvent Table
doc.setFont('helvetica', 'bold');
doc.text('Solvent', solventX, sideTableY);
autoTable(doc, {
  startY: sideTableY + 4,
  head: [['Solvent Type', 'Issue Qty', 'Return Qty', 'Consumption']],
  body: (entry.solvent || []).map((s: any) => [
    s.solType, s.solIssue, s.solReturn, s.solConsumption
  ]),
  foot: [[
    'Total', entry.totalSolventIssue || '0',
    entry.totalSolventReturn || '0',
    entry.totalSolventConsumption || '0'
  ]],
  theme: 'grid',
  styles: { fontSize: 9 },
  margin: { left: solventX },
  tableWidth: 80,

  footStyles: {
    fillColor: [240, 240, 240],  //gray color
    textColor: 20,
    fontStyle: 'bold'
  },
  headStyles: {
    fillColor: [60, 130, 200],
    textColor: 255
  },
});

// Breakdown Table
doc.setFont('helvetica', 'bold');
doc.text('Breakdown ', breakdownX, sideTableY);
autoTable(doc, {
  startY: sideTableY + 4,
  head: [['DownTime', 'Time', 'Remarks']],
  body: (entry.breakdown || []).map((b: any) => [
    b.downTime, b.downTimeTime, b.downTimeRemarks
  ]),
  foot: [['Total', entry.totalBreakdownTime || '0', '']],
  theme: 'grid',
  styles: { fontSize: 9 },
  margin: { left: breakdownX },
  tableWidth: 80,

  footStyles: {
    fillColor: [240, 240, 240],  //gray color
    textColor: 20,
    fontStyle: 'bold'
  },
  headStyles: {
    fillColor: [60, 130, 200],
    textColor: 255
  },
});

// Final PDF output
const pdfOutput = doc.output('bloburl');
window.open(pdfOutput);

}











printNewSep(entry: any) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const topMargin = 2;
  const sideMargin = 10;
  const adjustedTop = topMargin + 8;
  const adjustedLeft = sideMargin + 10;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);

  // Header
  const headerText = 'LEXIPACK GHANA LIMITED';
  const textWidth = doc.getTextWidth(headerText);
  doc.text(headerText, (pageWidth - textWidth) / 2, adjustedTop + 2);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);

  // Sub Header
  const subHeaderText = 'PRINTING REPORT';
  const subTextWidth = doc.getTextWidth(subHeaderText);
  doc.text(subHeaderText, (pageWidth - subTextWidth) / 2, adjustedTop + 10);

  let currentY = adjustedTop + 18;
  const formattedDate = new Date(entry.created).toISOString().split('T')[0];

  // Job Info Table
  autoTable(doc, {
    startY: currentY,
    body: [
      [
        { content: 'Job Name:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.jobName || '',
        { content: 'Order Number:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.ticketNo || '',
        { content: 'Ref No:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.refNo || '',
      ],
      [
        { content: 'Date:', styles: { fontStyle: 'bold', fontSize: 10 } },
        formattedDate,
        { content: 'Shift:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.shift || '',
        { content: 'Machine:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.machine || ''
      ],
      [
        { content: 'Operator:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.operator || '',
        { content: 'Machine Speed:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.mcSpeed || '',
        { content: 'Ink GSM:', styles: { fontStyle: 'bold', fontSize: 10 } },
        entry.inkGsm || ''
      ]
    ],
    theme: 'grid',
    styles: { fontSize: 10 },
    tableWidth: 'auto',
    margin: {
      left: sideMargin - 0
    },
    columnStyles: {
      0: { cellWidth: 25 },
      1: { cellWidth: 55 },
      2: { cellWidth: 20 },
      3: { cellWidth: 42 },
      4: { cellWidth: 22 },
      5: { cellWidth: 20 },
    }
  });

  currentY = (doc as any).lastAutoTable.finalY + 8;

  // Input and Output Data Table Title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('Input + Output Rolls', sideMargin, currentY);
  currentY += 4;

  // Table headers for input/output rolls
  const tableHeaders = [
    'S/N', 'Input Roll', 'Joint', 'Kgs', 'Return', 'Wastage', 'Output Roll', 'Kgs', 'Meters', 'Flags', 'Wastage'
  ];

  // Prepare table body data from materialDetails (input) and outputDetails (output)
  const tableBody = [];
  
  // Assuming entry.materialDetails and entry.outputDetails are arrays
  const materialDetails = entry.materialDetails || [];
  const outputDetails = entry.outputDetails || [];

  const maxLength = Math.max(materialDetails.length, outputDetails.length);

  // without footer
  // for (let i = 0; i < maxLength; i++) {
  //   const inputRow = materialDetails[i] || {};
  //   const outputRow = outputDetails[i] || {};

  //   tableBody.push([
  //     i + 1,
  //     inputRow.woNo || '', // Input Roll No
  //     inputRow.itemWidth || '', // Joint
  //     inputRow.itemGross || '', // Kgs
  //     inputRow.itemThickness || '', // Return
  //     inputRow.itemWastage || '', // Wastage
  //     outputRow.woNo || '', // Output Roll No
  //     outputRow.itemGross || '', // Output Kgs
  //     outputRow.itemMtrs || '', // Output Meters
  //     outputRow.itemWidth || '', // Output Flags
  //     outputRow.itemWastage || '' // Output Wastage
  //   ]);
  // }

  // with footer of input and output
  let totalInputKgs = 0;
let totalInputMeters = 0;
let totalInputFlags = 0;

let totalJoint = 0;
let totalReturn = 0;


let totalInputWastage = 0;

let totalOutputKgs = 0;
let totalOutputMeters = 0;
let totalOutputFlags = 0;
let totalOutputWastage = 0;



for (let i = 0; i < maxLength; i++) {
  const inputRow = materialDetails[i] || {};
  const outputRow = outputDetails[i] || {};

  // Calculate totals
  const inputKgs = parseFloat(inputRow.itemGross || '0');
  // const inputMeters = parseFloat(inputRow.itemWidth || '0');
  // const inputFlags = parseFloat(inputRow.itemThickness || '0');
  const inputJoints = parseFloat(inputRow.itemWidth || '0');
  const inputReturn = parseFloat(inputRow.itemThickness || '0');
  
  const inputWastage = parseFloat(inputRow.itemWastage || '0');

  const outputKgs = parseFloat(outputRow.itemGross || '0');
  const outputMeters = parseFloat(outputRow.itemMtrs || '0');
  const outputFlags = parseFloat(outputRow.itemWidth || '0');
  const outputWastage = parseFloat(outputRow.itemWastage || '0');

  // Update totals
  totalInputKgs += inputKgs;
  // totalInputMeters += inputMeters;
  // totalInputFlags += inputFlags;
  totalJoint  += inputJoints;
 totalReturn += inputReturn;

  totalInputWastage += inputWastage;

  totalOutputKgs += outputKgs;
  totalOutputMeters += outputMeters;
  totalOutputFlags += outputFlags;
  totalOutputWastage += outputWastage;
 

  tableBody.push([
    i + 1, // S/N
    inputRow.woNo || '', // Input Roll No
    inputRow.itemWidth || '', // Joint
    inputRow.itemGross || '', // Kgs
    inputRow.itemThickness || '', // Return
    inputRow.itemWastage || '', // Wastage
    outputRow.woNo || '', // Output Roll No
    outputRow.itemGross || '', // Output Kgs
    outputRow.itemMtrs || '', // Output Meters
    outputRow.itemWidth || '', // Output Flags
    outputRow.itemWastage || '' // Output Wastage
  ]);
}

  // Table rendering
  autoTable(doc, {
    startY: currentY,
    head: [tableHeaders],
    body: tableBody,
    theme: 'grid',
    styles: {
      fontSize: 9,
      cellPadding: 1.5,
    },
    headStyles: {
      fillColor: [60, 130, 200],
      textColor: 255,
      cellPadding: { top: 3, bottom: 3, left: 2 }
    },
    margin: { left: sideMargin, right: sideMargin },
    tableWidth: 'auto',
    columnStyles: {
      0: { cellWidth: 10 },
      1: { cellWidth: 20 },
      2: { cellWidth: 20 },
      3: { cellWidth: 14 },
      4: { cellWidth: 18 },
      5: { cellWidth: 18 },
      6: { cellWidth: 20 },
      7: { cellWidth: 18 },
      8: { cellWidth: 18 },
      9: { cellWidth: 17 },
      10: { cellWidth: 17 }
    },
    foot: [
      [
        '', // Empty space for S/N column
        // { content: 'Total:', colSpan: 1, styles: { fontStyle: 'bold', fillColor: [180, 180, 180] } },
        { content: 'Total:', colSpan: 1, styles: { fontStyle: 'bold'} },
        totalJoint.toFixed(2),
        totalInputKgs.toFixed(2),
       
        totalReturn.toFixed(2),
        totalInputWastage.toFixed(2),
        
        '', // Empty for Output Roll No
        totalOutputKgs.toFixed(2),
        totalOutputMeters.toFixed(2),
        totalOutputFlags.toFixed(2),
        totalOutputWastage.toFixed(2)
      ],
      [
        '', '', 
        { content: 'Return:', styles: { fontStyle: 'bold' } },
        totalReturn.toFixed(2),
        '', '', 
        { content: 'Wastage:', styles: { fontStyle: 'bold' } },
        totalOutputWastage.toFixed(2),
        '', '', ''
      ],
      [
        '', 
        { content: 'Net Consumption:', colSpan: 2, styles: { fontStyle: 'bold' } },
        { content: entry.netConsumption || '0.00', styles: { fontStyle: 'bold'} },
        '', '', 
        { content: 'Net Total:', styles: { fontStyle: 'bold' } },
        { content: entry.netConsumptionOutputRoll || '0.00', styles: { fontStyle: 'bold' } }
      ]
    ],
    footStyles: {
      fillColor: [240, 240, 240], // Light gray background for the footer row
      textColor: 20, // Dark text color
      fontStyle: 'bold'
    }
  });

  currentY = (doc as any).lastAutoTable.finalY + 10;

  // ------- Inking Summary ---------
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('Inks', sideMargin, currentY); 
  currentY += 4;

  autoTable(doc, {
    startY: currentY,
    head: [['Ink Name', 'Ink Color', 'Ink Type', 'Issue (Kgs)', 'Return (Kgs)', 'Liquid Cons', 'Solid %', 'Solid Cons']],
    body: (entry.inking || []).map((ink: any) => [
      ink.inkName || '',
      ink.inkColor || '',
      ink.inkType || '',
      ink.issue,

      // '', // Return can be blank if not stored per ink
      ink.return,
  
      ink.liquidCons,
      ink.solidPercent,
      ink.solidCons
    ]),
    styles: { fontSize: 9 },
    margin: { left: sideMargin, right: sideMargin },
    tableWidth: 'auto',
    // columnStyles: {
    //   0: { cellWidth: 30 },
    //   1: { cellWidth: 18 },
    //   2: { cellWidth: 18 },
    //   3: { cellWidth: 14 },
    //   4: { cellWidth: 14 },
    //   5: { cellWidth: 18 },
    //   6: { cellWidth: 16 },
    //   7: { cellWidth: 16 }
    // }
    foot: [[
      'Total', '', '', entry.totalInkIssue || '0',
      entry.totalInkReturn || '0',
      entry.totalInkLiquidCons || '0',
      '', entry.totalInkSolidCons || '0'
    ]],
    theme: 'grid',
    footStyles: {
      fillColor: [240, 240, 240],  //gray color
      textColor: 20,
      fontStyle: 'bold'
    },
    headStyles: {
      fillColor: [60, 130, 200],
      textColor: 255
    },
  });

  currentY = (doc as any).lastAutoTable.finalY + 10;




  

  // ------- Solvent Summary ---------
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('Solvent Usage', sideMargin, currentY); 
  currentY += 4;

  autoTable(doc, {
    startY: currentY,
    head: [['Solvent Type', 'Issue Qty', 'Return Qty', 'Consumption']],
    body: (entry.solvent || []).map((s: any) => [
      s.solType, s.solIssue, s.solReturn, s.solConsumption
    ]),
    foot: [[
      'Total', entry.totalSolventIssue || '0',
      entry.totalSolventReturn || '0',
      entry.totalSolventConsumption || '0'
    ]],
    theme: 'grid',
    styles: { fontSize: 9 },
    margin: { left: sideMargin, right: sideMargin },
    tableWidth: 'auto',
    // columnStyles: {
    //   0: { cellWidth: 30 },
    //   1: { cellWidth: 20 },
    //   2: { cellWidth: 20 },
    //   3: { cellWidth: 20 }
    // }
    footStyles: {
      fillColor: [240, 240, 240],  //gray color
      textColor: 20,
      fontStyle: 'bold'
    },
    headStyles: {
      fillColor: [60, 130, 200],
      textColor: 255
    },
  });

  currentY = (doc as any).lastAutoTable.finalY + 10;

  



  // ------- Breakdown Summary ---------
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('Breakdowns', sideMargin, currentY); 
  currentY += 4;

  autoTable(doc, {
    startY: currentY,
    head: [['DownTime', 'Time', 'Remarks']],
  body: (entry.breakdown || []).map((b: any) => [
    b.downTime, b.downTimeTime, b.downTimeRemarks
  ]),
  foot: [['Total', entry.totalBreakdownTime || '0', '']],
  theme: 'grid',
    styles: { fontSize: 9 },
    margin: { left: sideMargin, right: sideMargin },
    tableWidth: 'auto',
    // columnStyles: {
    //   0: { cellWidth: 30 },
    //   1: { cellWidth: 20 },
    //   2: { cellWidth: 20 },
    //   3: { cellWidth: 20 },
    //   4: { cellWidth: 20 }
    // }
    footStyles: {
      fillColor: [240, 240, 240],  //gray color
      textColor: 20,
      fontStyle: 'bold'
    },
    headStyles: {
      fillColor: [60, 130, 200],
      textColor: 255
    },
  });

  // Finalize PDF
  // doc.save('PrintingReport.pdf');  //for downloading

  // Final PDF output
const pdfOutput = doc.output('bloburl');
window.open(pdfOutput);
}









// print(entry: any) {
//   const doc = new jsPDF();

//   const pageWidth = doc.internal.pageSize.width;
//   const topMargin = 2;
//   const sideMargin = 10;
//   const adjustedTop = topMargin + 8;
//   const adjustedLeft = sideMargin + 10;

//   doc.setFont('helvetica', 'bold');
//   doc.setFontSize(13);

//   // Header
//   const headerText = 'LEXIPACK GHANA LIMITED';
//   const textWidth = doc.getTextWidth(headerText);
//   const textX = (pageWidth - textWidth) / 2;
//   doc.text(headerText, textX, adjustedTop + 2);

//   doc.setFontSize(11);
//   doc.setFont('helvetica', 'normal');

//   // Company Info
//   doc.text(`Client Name: ${entry.clientName || ''}`, adjustedLeft, adjustedTop + 10);
//   doc.text(`Job Name: ${entry.jobName || ''}`, adjustedLeft, adjustedTop + 16);
//   doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);

//   let currentY = adjustedTop + 25;

//   // General Info
//   const lines = [
//     `PO No: ${entry.poNumber || ''}`,
//     `Ref No: ${entry.refNo || ''}`,
//     `Shift: ${entry.shift || ''}`,
//     `Machine: ${entry.machine || ''}`,
//     `Operator: ${entry.operator || ''}`,
//     `Operating Time: ${entry.operatingTime || ''}`,
//     `Machine Speed: ${entry.mcSpeed || ''}`,
//     `Ink GSM: ${entry.inkGsm || ''}`,
//     `Order Quantity: ${entry.orderKgs || ''} kg`,
//     `Time From: ${entry.timeFrom || ''}`,
//     `Time To: ${entry.timeTo || ''}`
//   ];

//   lines.forEach(line => {
//     doc.text(line, adjustedLeft, currentY);
//     currentY += 7;
//   });

//   // AddProduction Details (only first item shown)
//   if (entry.addProduction?.length) {
//     const prod = entry.addProduction[0];
//     doc.setFont('helvetica', 'bold');
//     doc.text('Material Details:', adjustedLeft, currentY + 5);
//     doc.setFont('helvetica', 'normal');
//     currentY += 12;

//     doc.text(`Material Spec: ${prod.matSpecifications || 'N/A'}`, adjustedLeft, currentY);
//     currentY += 7;
//     doc.text(`Material Roll No: ${prod.matRollNo || 'N/A'}`, adjustedLeft, currentY);
//     currentY += 7;
//     doc.text(`Produced Weight: ${prod.prodWeight || 'N/A'} kg`, adjustedLeft, currentY);
//     currentY += 7;
//     doc.text(`Returned Weight: ${prod.prodReturn || 'N/A'} kg`, adjustedLeft, currentY);
//     currentY += 10;
//   }

//   // Inking Details
//   if (entry.inking?.length) {
//     doc.setFont('helvetica', 'bold');
//     doc.text('Ink Details:', adjustedLeft, currentY);
//     doc.setFont('helvetica', 'normal');
//     currentY += 8;

//     entry.inking.forEach((ink: any, index: number) => {
//       const inkLine = `${index + 1}. ${ink.inkName || 'N/A'} | Color: ${ink.inkColor || 'N/A'} | Type: ${ink.inkType || 'N/A'} | Issue: ${ink.issue || 'N/A'} | Return: ${ink.inkReturn || 'N/A'}`;
//       doc.text(inkLine, adjustedLeft, currentY);
//       currentY += 7;
//     });
//   }

//   // Final line
//   doc.line(sideMargin, currentY + 2, pageWidth - sideMargin, currentY + 2);

//   // Open PDF
//   const pdfOutput = doc.output('bloburl');
//   window.open(pdfOutput);
// }





exportToExcel(entry: any): void {
  const data = entry;
  if (!data || !data.materialDetails) {
    alert('No data to export.');
    return;
  }

  const wsData: any[][] = [];

  // Title
  wsData.push(['LEXIPACK GHANA LIMITED', '', '', '', '', '', '', '',  'PRINTING REPORT']);
  wsData.push([]);

  // Job Info
  wsData.push(['Job Name:', data.jobName || '', 'Order Number:', data.ticketNo || '', 'Ref No:', data.refNo || '']);
  wsData.push(['Shift:', data.shift || '', 'Machine:', data.machine || '']);
  wsData.push(['Operator:', data.operator || '', 'Machine Speed:', data.mcSpeed || '', 'Ink GSM:', data.inkGsm || '']);

  wsData.push([]);

  // Table Header
  wsData.push([]); // empty line before table
// wsData.push(['Input + Output']);  // <-- your label here
wsData.push(['', 'INPUT', '', '', '', '', 'OUTPUT']); // merged labels
  wsData.push([
    'S/N', 'Input Roll', 'Joint', 'Kgs', 'Return', 'Wastage',
    'Output Roll', 'Kgs', 'Meters', 'Flags', 'Wastage'
  ]);

  data.materialDetails.forEach((row: any, i: number) => {
    const batches = Array.isArray(row.batches) ? row.batches : [];

    if (batches.length > 0) {
      batches.forEach((batch: any, idx: number) => {
        if (idx === 0) {
          wsData.push([
            i + 1,
            row.woNo || '',
            row.itemWidth || '',
            row.itemGross || '',
            row.itemThickness || '',
            row.itemWastage || '',
            batch.batchNo || '',
            batch.dialogColor || '',
            batch.dialogMeter || '',
            batch.dialogText || '',
            batch.remark || ''
          ]);
        } else {
          wsData.push([
            '', '', '', '', '', '',
            batch.batchNo || '',
            batch.dialogColor || '',
            batch.dialogMeter || '',
            batch.dialogText || '',
            batch.remark || ''
          ]);
        }
      });
    } else {
      wsData.push([
        i + 1,
        row.woNo || '',
        row.itemWidth || '',
        row.itemGross || '',
        row.itemThickness || '',
        row.itemWastage || '',
        '', '', '', '', ''
      ]);
    }
  });

  // Totals
  wsData.push([]);
  wsData.push([
    '', 'TOTAL :', data.totalJoint || '0', data.totalKgs || '0',
    data.totalReturn || '0', data.totalWastage || '0',
    '', data.totalOutputKgs || '0', data.totalOutputMeters || '0',
    data.totalOutputFlags || '0', data.totalOutputWastage || '0'
  ]);
  wsData.push([
    '', '', 'Return :', data.totalReturn || '0.00',
    '', '', 'Wastage :', data.totalOutputWastage || '0.00',
    '', '', ''
  ]);
  wsData.push([
    '', '', 'Net Consumption :', data.netConsumption || '0',
    '', '', 'Net Total :', data.netTotalConsumption || '0',
    '', '', ''
  ]);

  wsData.push([]);

  // Inks
  wsData.push([]);
  wsData.push(['INKS']);
  wsData.push(['Ink Name', 'Ink Color', 'Ink Type', 'Issue (Kgs)', 'Return (Kgs)', 'Liquid Cons', 'Solid %', 'Solid Cons']);
  (data.inking || []).forEach((ink: any) => {
    wsData.push([
      ink.inkName,
      ink.inkColor,
      ink.inkType,
      ink.issue,
      ink.return,
      ink.liquidCons,
      ink.solidPercent,
      ink.solidCons
    ]);
  });
  wsData.push(['TOTAL', '', '', data.totalInkIssue || '0', data.totalInkReturn || '0', data.totalInkLiquidCons || '0', '', data.totalInkSolidCons || '0']);

  wsData.push([]);

  // Solvent + Breakdown
  wsData.push(['SOLVENT', '', '', '', '', '', 'BREAKDOWN']);
  wsData.push(['Solvent Type', 'Issue Qty', 'Return Qty', 'Consumption', '', '', 'DownTime', 'Time', 'Remarks']);
  const maxLen = Math.max((data.solvent || []).length, (data.breakdown || []).length);
  for (let i = 0; i < maxLen; i++) {
    const sol = data.solvent?.[i];
    const brk = data.breakdown?.[i];
    wsData.push([
      sol?.solType || '', sol?.solIssue || '', sol?.solReturn || '', sol?.solConsumption || '',
      '', '',
      brk?.downTime || '', brk?.downTimeTime || '', brk?.downTimeRemarks || ''
    ]);
  }
  wsData.push(['TOTAL', data.totalSolventIssue || '0', data.totalSolventReturn || '0', data.totalSolventConsumption || '0', '', '', 'TOTAL', data.totalBreakdownTime || '0', '']);

  // Sheet setup
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(wsData);
  worksheet['!merges'] = [
    // Merge cells for "Input" (A7 to F7) and "Output" (G7 to K7)
    { s: { r: 6, c: 0 }, e: { r: 6, c: 5 } },  // A7:F7
    { s: { r: 6, c: 6 }, e: { r: 6, c: 10 } }, // G7:K7

    { s: { r: 0, c: 0 }, e: { r: 1, c: 4 } }, //for title lexipack ghana
    
    // { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } }
    { s: { r: 0, c: 8 }, e: { r: 1, c: 9 } }   // PRINTING REPORT (I1:J1) — shifted left by 2
  ];
  const maxCols = Math.max(...wsData.map(row => row.length));
  worksheet['!cols'] = Array.from({ length: maxCols }, () => ({ wch: 15 }));

  const workbook: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Printing Report');
  XLSX.writeFile(workbook, `Printing_Report_${data.refNo || 'entry'}.xlsx`);
}





  // error one
  // Method to load all productions
  // loadAllProductions(): void {
  //   this.productionService.getAllProduction().subscribe(
  //     (productions) => {
  //       this.productions = productions;
  //       console.log('Loaded productions:', productions);
  //     },
  //     (error) => {
  //       console.error('Error loading productions:', error);
  //     }
  //   );
  // }


  //grouping
  // groupEntriesByCommonFields(): void {
  //   const grouped = {};
    
  //   this.materialMixEntries.forEach(entry => {
  //     const key = `${entry.refNo}-${entry.clientName}-${entry.jobName}-${entry.poNumber}-${entry.orderKgs}`;

  //     // Initialize the group if it doesn't exist
  //     if (!grouped[key]) {
  //       grouped[key] = { 
  //         ...entry, 
  //         matRollNos: new Set([entry.matRollNo]),  // Track matRollNo to avoid duplicate entries
  //         availTime: entry.addProduction[0]?.availTime || 'N/A'
  //       };
  //     } else {
  //       // Check for matRollNo changes, if it's different, create a new entry
  //       if (!grouped[key].matRollNos.has(entry.matRollNo)) {
  //         console.log('New matRollNo detected:', entry.matRollNo);  // Log for debugging
  //         grouped[key].matRollNos.add(entry.matRollNo);  // Add matRollNo to set
  //         // Optionally, you could add the new entry to a new row if needed
  //       }
  //     }
  //   });

  //   // Log the grouped data for debugging
  //   console.log('Grouped data:', grouped);
    
  //   // Convert the grouped object into an array for binding to the table
  //   this.groupedEntries = Object.values(grouped);
    
  //   // Log the final grouped entries for debugging
  //   console.log('Grouped Entries for Table:', this.groupedEntries);
  // }



  
  // groupEntriesByCommonFields(): void {
  //   const grouped: { [key: string]: any } = {};  // Make sure grouped is typed correctly
  
  //   this.materialMixEntries.forEach(entry => {
  //     const key = `${entry.refNo}-${entry.clientName}-${entry.jobName}-${entry.poNumber}-${entry.orderKgs}`;
  
  //     // Initialize the group if it doesn't exist
  //     if (!grouped[key]) {
  //       grouped[key] = {
  //         ...entry,
  //         matRollNos: new Set([entry.matRollNo]),  // Track matRollNo to avoid duplicate entries
  //         availTime: entry.addProduction[0]?.availTime || 'N/A',
  //         entries: [entry]  // Store all grouped entries
  //       };
  //       console.log(`Creating new group for key: ${key}`, entry);  // Log the first entry of the group
  //     } else {
  //       // Check for matRollNo changes, if it's different, create a new entry
  //       if (!grouped[key].matRollNos.has(entry.matRollNo)) {
  //         console.log('New matRollNo detected:', entry.matRollNo);  // Log for debugging
  //         grouped[key].matRollNos.add(entry.matRollNo);  // Add matRollNo to set
  //         // Add the new entry to the entries array
  //         grouped[key].entries.push(entry);  // Add to the group
  //         console.log(`Added new entry to group for key: ${key}`, entry);  // Log the new entry added
  //       }
  //     }
  //   });
  
  //   // Log the grouped data for debugging, including the full group with entries
  //   console.log('Grouped data with entries:', grouped);
  
  //   // Use reduce to flatten the entries from all groups
  //   this.groupedEntries = Object.values(grouped).reduce<any[]>((acc, group) => {
  //     return acc.concat(group.entries);  // Concatenate all the entries into one array
  //   }, []);  // Start with an empty array
  
  //   // Log the final grouped entries for debugging
  //   console.log('Grouped Entries for Table:', this.groupedEntries);
  // }



  //grouping with diff matrollno
  //Showed
  groupEntriesByCommonFields(): void {
    const grouped: { [key: string]: any } = {};  // Group entries by common fields
  
    this.materialMixEntries.forEach(entry => {
      // Ensure addProduction array and matRollNo exist before using them
      const matRollNo = entry.addProduction && entry.addProduction[0]?.matRollNo;
      if (!matRollNo) {
        console.warn(`matRollNo is missing for entry with refNo: ${entry.refNo}`);
      }
  
      // Create a unique key for grouping
      const key = `${entry.refNo}-${entry.clientName}-${entry.jobName}-${entry.poNumber}-${entry.orderKgs}`;
  
      // Initialize group if it doesn't exist
      if (!grouped[key]) {
        grouped[key] = {
          matRollNos: new Set([matRollNo]),  // Track matRollNo to avoid duplicates
          availTime: entry.addProduction[0]?.availTime || 'N/A',
          entries: [entry],  // Store entries that belong to this group
        };
      } else {
        // Check if matRollNo is different, and add the entry to the group's entries
        if (matRollNo && !grouped[key].matRollNos.has(matRollNo)) {
          grouped[key].matRollNos.add(matRollNo);
          grouped[key].entries.push(entry);  // Add new entry for different matRollNo


          // (detail detail)
          // Log the details of addProduction array when matRollNo is different
        // console.log(`matRollNo is different in group: ${grouped[key].entries[0].refNo}`);
        // console.log('Details of addProduction for the current entry:', entry.addProduction);
        }
      }
    });
  
    // Log different matRollNo values for each group
    Object.entries(grouped).forEach(([groupKey, groupValue]) => {
      console.log(`Group: ${groupKey}`);  // Log group key (refNo-clientName-jobName-poNumber-orderKgs)
  
      // If there are multiple unique matRollNo values
      if (groupValue.matRollNos.size > 1) {
        console.log('Different matRollNo values in this group:', Array.from(groupValue.matRollNos));
      } else {
        console.log('Same matRollNo across all entries in this group:', Array.from(groupValue.matRollNos));
      }
    });
  
    // Flatten the entries from all groups into a single array
    this.groupedEntries = Object.values(grouped).reduce<any[]>((acc, group) => {
      return acc.concat(group.entries);  // Concatenate entries, including those with different matRollNo
    }, []);
  }



  //Showed(but with repitition count)
  // groupEntriesByCommonFields(): void {
  //   const grouped: { [key: string]: any } = {};  // Group entries by common fields
  //   const matRollNoCount: { [matRollNo: string]: number } = {};  // To count repetitions of each matRollNo
    
  //   this.materialMixEntries.forEach(entry => {
  //     // Ensure addProduction array and matRollNo exist before using them
  //     const matRollNo = entry.addProduction && entry.addProduction[0]?.matRollNo;
  //     if (!matRollNo) {
  //       console.warn(`matRollNo is missing for entry with refNo: ${entry.refNo}`);
  //     }
  
  //     // Create a unique key for grouping
  //     const key = `${entry.refNo}-${entry.clientName}-${entry.jobName}-${entry.poNumber}-${entry.orderKgs}`;
  
  //     // Initialize group if it doesn't exist
  //     if (!grouped[key]) {
  //       grouped[key] = {
  //         matRollNos: new Set([matRollNo]),  // Track matRollNo to avoid duplicates
  //         availTime: entry.addProduction[0]?.availTime || 'N/A',
  //         entries: [entry],  // Store entries that belong to this group
  //       };
  //     } else {
  //       // Check if matRollNo is different, and add the entry to the group's entries
  //       if (matRollNo && !grouped[key].matRollNos.has(matRollNo)) {
  //         grouped[key].matRollNos.add(matRollNo);
  //         grouped[key].entries.push(entry);  // Add new entry for different matRollNo
  //       }
  //     }
  
  //     // Track how many times this matRollNo appears across all groups
  //     if (matRollNo) {
  //       matRollNoCount[matRollNo] = (matRollNoCount[matRollNo] || 0) + 1;
  //     }
  //   });
  
  //   // Log the matRollNo counts to see repetitions
  //   console.log("matRollNo repetitions:");
  //   Object.entries(matRollNoCount).forEach(([matRollNo, count]) => {
  //     console.log(`matRollNo: ${matRollNo} is repeated ${count} times.`);
  //   });
  
  //   // Log different matRollNo values for each group
  //   Object.entries(grouped).forEach(([groupKey, groupValue]) => {
  //     console.log(`Group: ${groupKey}`);  // Log group key (refNo-clientName-jobName-poNumber-orderKgs)
  
  //     // If there are multiple unique matRollNo values
  //     if (groupValue.matRollNos.size > 1) {
  //       console.log('Different matRollNo values in this group:', Array.from(groupValue.matRollNos));
  //     } else {
  //       console.log('Same matRollNo across all entries in this group:', Array.from(groupValue.matRollNos));
  //     }
  //   });
  
  //   // Flatten the entries from all groups into a single array
  //   this.groupedEntries = Object.values(grouped).reduce<any[]>((acc, group) => {
  //     return acc.concat(group.entries);  // Concatenate entries, including those with different matRollNo
  //   }, []);
  // }
  
  
  
  



}



//grouping
  // groupEntriesByCommonFields(): void {
  //   const grouped = {};
    
  //   this.materialMixEntries.forEach(entry => {
  //     const key = `${entry.refNo}-${entry.clientName}-${entry.jobName}-${entry.poNumber}-${entry.orderKgs}`;

  //     // Initialize the group if it doesn't exist
  //     if (!grouped[key]) {
  //       grouped[key] = { 
  //         ...entry, 
  //         matRollNos: new Set([entry.matRollNo]),  // Track matRollNo to avoid duplicate entries
  //         availTime: entry.addProduction[0]?.availTime || 'N/A'
  //       };
  //     } else {
  //       // Check for matRollNo changes, if it's different, create a new entry
  //       if (!grouped[key].matRollNos.has(entry.matRollNo)) {
  //         console.log('New matRollNo detected:', entry.matRollNo);  // Log for debugging
  //         grouped[key].matRollNos.add(entry.matRollNo);  // Add matRollNo to set
  //         // Optionally, you could add the new entry to a new row if needed
  //       }
  //     }
  //   });

  //   // Log the grouped data for debugging
  //   console.log('Grouped data:', grouped);
    
  //   // Convert the grouped object into an array for binding to the table
  //   this.groupedEntries = Object.values(grouped);
    
  //   // Log the final grouped entries for debugging
  //   console.log('Grouped Entries for Table:', this.groupedEntries);
  // }

